import * as React from 'react'
import Layout from '../shared/components/organisms/layout/layout'
import { LayoutCollege } from '../components/organisms/layout-college/layout-college'
import { HomePage } from '../components/organisms/home-page/home-page'
import { ModalTerms } from '../components/atoms/modal-terms/modal-terms'
import NewProductInfo from '../components/atoms/new-product-info/new-product-info'
import SeoImg from '../assets/images/header/header-college-desktop.svg'
import SEO from '../shared/seo'
import { Context } from '../context/app-context'
import { siteUrl } from '../shared/utils/siteUrl'

import useMediaQuery from '../shared/utils/useMediaQuery'
import useUrlIdRegister from '../utils/useUrlIdRegister'

function IndexPage({ location }) {
  const isMobile = useMediaQuery()
  const [isTycModal, setIsTycModal] = React.useState(false)
  const { modalActive, userInfo } = React.useContext(Context)
  const isBrowser = typeof window !== 'undefined'

  const closeModalTerms = () => {
    if (isBrowser) window.location.hash = '#'
    setIsTycModal(false)
  }

  React.useEffect(() => {
    if (location?.hash?.includes('terminos-y-condiciones')) {
      setIsTycModal(true)
    }
  }, [location])

  const urlRegister = useUrlIdRegister()

  const redirectRegister = () => {
    return siteUrl + urlRegister
  }

  return (
    <Layout mobile={isMobile} defaultUserInfo={userInfo} redirectRegister={redirectRegister}>
      <SEO
        title="Cole Challenge"
        description="Nosotras colegios 2022"
        image={SeoImg}
      />
      <NewProductInfo />
      <LayoutCollege />
      <HomePage />
      {modalActive && <div className="f-modal-container">{modalActive}</div>}
      {isTycModal && <ModalTerms onClose={closeModalTerms} />}
    </Layout>
  )
}

export default IndexPage
